var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('blur-hash-image',{staticClass:"mb-4",attrs:{"hash":_vm.contentElement.image.hash,"src":_vm.contentElement.image.url,"alt":_vm.contentElement.title,"width":20,"height":Math.floor(20 / _vm.contentElement.image.aspectRatio)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }